// import React, { useEffect, useState } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";

// const EditSchoolNotes = () => {
//   const [schoolClassName, setSchoolClassName] = useState([]);
//   const [schoolClassNameId, setSchoolClassNameId] = useState("");
//   const [subjects, setSubjects] = useState([]);
//   const [subjectId, setSubjectId] = useState("");
//   const [noteTitle, setNoteTitle] = useState("");
//   const [file, setFile] = useState(null); // Capture the actual file object
//   const [language, setLanguage] = useState("");

//   const { id } = useParams(); // Get the note ID from the route params
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   useEffect(() => {
//     // Fetch note data by ID and populate the state
//     axios
//       .get(`${API_BASE_URL}/notes/${id}`)
//       .then((response) => {
//         const { data } = response.data;
//         setSchoolClassNameId(data.schoolClassNameId);
//         setSubjectId(data.subjectId);
//         setNoteTitle(data.noteTitle);
//         setLanguage(data.language);
//       })
//       .catch((error) => console.log(error));
//   }, [id, API_BASE_URL]);

//   useEffect(() => {
//     // Fetch available classes
//     axios
//       .get(`${API_BASE_URL}/classes`)
//       .then((response) => setSchoolClassName(response.data.data))
//       .catch((error) => console.log(error));

//     // Fetch subjects based on class ID
//     if (schoolClassNameId) {
//       axios
//         .get(`${API_BASE_URL}/subjects?classId=${schoolClassNameId}`)
//         .then((response) => setSubjects(response.data.data))
//         .catch((error) => console.log(error));
//     }
//   }, [schoolClassNameId, API_BASE_URL]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("noteTitle", noteTitle);
//     formData.append("language", language);
//     if (file) {
//       formData.append("noteFile", file);
//     }

//     axios
//       .put(`${API_BASE_URL}/admin/notes/${id}`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then(() => {
//         alert("Note updated successfully!");
//         navigate("/upload-notes/all-school-notes");
//       })
//       .catch((error) => console.log(error));
//   };

//   const handleGoBack = () => {
//     navigate("/upload-notes/upload-all-notes");
//   };

//   return (
//     <div id="exam-school-notes-inner-wrapper">
//       <div className="main-header">
//         <BiArrowBack
//           onClick={handleGoBack}
//           className="left-arrow-icon"
//           style={{
//             cursor: "pointer",
//             fontSize: "25px",
//             color: "#000",
//           }}
//         />
//         <div className="exam-header-div">
//           <h5>Edit School Note</h5>
//           <div className="exam-btn-group">
//             <button
//               className="addNewNoteBtn"
//               onClick={() => navigate("/upload-notes/upload-school-notes")}
//             >
//               + Upload Notes
//             </button>
//             <button
//               className="viewAllNotesBtn"
//               onClick={() => navigate("/upload-notes/all-school-notes")}
//             >
//               All Notes
//             </button>
//           </div>
//         </div>

//         <div className="form-container" id="form">
//           <h4 className="note-detail">Edit Note Details</h4>
//           <form onSubmit={handleSubmit} className="note-detail-form">
//             {/* <div className="input-group">
//               <label className="label">Class Name</label>
//               <select
//                 className="select-dropdown"
//                 value={schoolClassNameId}
//                 onChange={(e) => setSchoolClassNameId(e.target.value)}
//                 required
//               >
//                 <option value="">-Select Class-</option>
//                 {schoolClassName.map((classItem) => (
//                   <option key={classItem._id} value={classItem._id}>
//                     {classItem.className}
//                   </option>
//                 ))}
//               </select>
//             </div> */}

//             {/* <div className="new-chapter-form-group">
//               <label className="new-chapter-label">Subject Name</label>
//               <select
//                 className="new-chapter-dropdown"
//                 value={subjectId}
//                 onChange={(e) => setSubjectId(e.target.value)}
//                 required
//               >
//                 <option value="">-Select Subject-</option>
//                 {subjects.map((subject) => (
//                   <option key={subject._id} value={subject._id}>
//                     {subject.subjectName}
//                   </option>
//                 ))}
//               </select>
//             </div> */}

//             <div className="input-group">
//               <label className="label">Note Title</label>
//               <input
//                 type="text"
//                 value={noteTitle}
//                 onChange={(e) => setNoteTitle(e.target.value)}
//                 placeholder="Enter Note Title"
//                 required
//               />
//             </div>

//             <div className="input-group">
//               <label className="label">Language</label>
//               <input
//                 type="radio"
//                 value="hindi"
//                 checked={language === "hindi"}
//                 onChange={(e) => setLanguage(e.target.value)}
//                 required
//               />{" "}
//               Hindi
//               <input
//                 type="radio"
//                 value="english"
//                 checked={language === "english"}
//                 onChange={(e) => setLanguage(e.target.value)}
//                 required
//               />{" "}
//               English
//             </div>

//             <div className="input-group">
//               <label className="label">Upload File (pdf format)</label>
//               <input
//                 type="file"
//                 onChange={(e) => setFile(e.target.files[0])}
//                 accept=".pdf"
//               />
//             </div>

//             <div className="form1-btns">
//               <button className="btn-save">Save</button>
//               <button
//                 type="button"
//                 className="btn-cancel"
//                 onClick={handleGoBack}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditSchoolNotes;






import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditSchoolNotes = () => {

  const [noteTitle, setNoteTitle] = useState("");
  const [language, setLanguage] = useState("");
  const [file, setFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState(""); // ✅ NEW

  const [existingPdf, setExistingPdf] = useState(""); // optional display

  const { id } = useParams();

  const navigate = useNavigate();

  const API_BASE_URL =
    process.env.REACT_APP_API_BASEURL;



  /* ================= FETCH NOTE ================= */
  useEffect(() => {

    axios
      .get(`${API_BASE_URL}/notes/${id}`)
      .then((response) => {

        const note =
          response.data.data;

        setNoteTitle(note.noteTitle);
        setLanguage(note.language);
        setVideoUrl(note.videoUrl || "");
        setExistingPdf(note.noteFile || "");

      })
      .catch(console.log);

  }, [id]);



  /* ================= FILE CHANGE ================= */
  const handleFileChange = (e) => {

    const selectedFile =
      e.target.files[0];

    if (
      selectedFile &&
      selectedFile.type !==
      "application/pdf"
    ) {

      alert("Only PDF allowed");

      return;

    }

    setFile(selectedFile);

  };



  /* ================= UPDATE NOTE ================= */
  // const handleSubmit = (e) => {

  //   e.preventDefault();


  //   if (!file && !videoUrl && !existingPdf) {

  //     alert(
  //       "PDF or Video URL required"
  //     );

  //     return;

  //   }


  //   const formData =
  //     new FormData();

  //   formData.append(
  //     "noteTitle",
  //     noteTitle
  //   );

  //   formData.append(
  //     "language",
  //     language
  //   );

  //   if (videoUrl)
  //     formData.append(
  //       "videoUrl",
  //       videoUrl
  //     );

  //   if (file)
  //     formData.append(
  //       "noteFile",
  //       file
  //     );


  //   axios
  //     .put(
  //       `${API_BASE_URL}/admin/notes/${id}`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization:
  //             `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {

  //       alert(
  //         "Note updated successfully!"
  //       );

  //       navigate(
  //         "/upload-notes/all-school-notes"
  //       );

  //     })
  //     .catch((error) => {

  //       console.log(error);

  //       alert(
  //         error.response?.data?.msg ||
  //         "Update failed"
  //       );

  //     });

  // };


  const handleSubmit = (e) => {

    e.preventDefault();

    if (!file && !videoUrl && !existingPdf) {
      alert("PDF or Video URL required");
      return;
    }

    const formData = new FormData();

    formData.append("noteTitle", noteTitle);
    formData.append("language", language);

    if (videoUrl) formData.append("videoUrl", videoUrl);

    if (file) formData.append("noteFile", file);

    const role = localStorage.getItem("role");

    // decide endpoint based on role
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/notes/${id}`
        : `${API_BASE_URL}/admin/notes/${id}`;

    axios
      .put(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        alert("Note updated successfully!");
        navigate("/upload-notes/all-school-notes");
      })
      .catch((error) => {
        console.log(error);
        alert(error.response?.data?.msg || "Update failed");
      });
  };


  const handleGoBack =
    () =>
      navigate(
        "/upload-notes/upload-all-notes"
      );



  return (

    <div id="exam-school-notes-inner-wrapper">

      <div className="main-header">

        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            fontSize: "25px",
          }}
        />



        <div className="exam-header-div">

          <h5>Edit School Note</h5>

          <div className="exam-btn-group">

            <button
              className="addNewNoteBtn"
              onClick={() =>
                navigate(
                  "/upload-notes/upload-school-notes"
                )
              }
            >
              + Upload Notes
            </button>


            <button
              className="viewAllNotesBtn"
              onClick={() =>
                navigate(
                  "/upload-notes/all-school-notes"
                )
              }
            >
              All Notes
            </button>

          </div>

        </div>



        <div className="form-container">

          <h4 className="note-detail">
            Edit Note Details
          </h4>



          <form
            onSubmit={handleSubmit}
            className="note-detail-form"
          >



            {/* TITLE */}
            <div className="input-group">

              <label>
                Note Title
              </label>

              <input
                type="text"
                value={noteTitle}
                onChange={(e) =>
                  setNoteTitle(
                    e.target.value
                  )
                }
                required
              />

            </div>



            {/* LANGUAGE */}
            <div className="input-group">

              <label>
                Language
              </label>


              <label>

                <input
                  type="radio"
                  value="hindi"
                  checked={
                    language ===
                    "hindi"
                  }
                  onChange={(e) =>
                    setLanguage(
                      e.target.value
                    )
                  }
                />

                Hindi

              </label>


              <label
                style={{
                  marginLeft: "15px"
                }}
              >

                <input
                  type="radio"
                  value="english"
                  checked={
                    language ===
                    "english"
                  }
                  onChange={(e) =>
                    setLanguage(
                      e.target.value
                    )
                  }
                />

                English

              </label>

            </div>



            {/* EXISTING PDF */}
            {existingPdf && (

              <div className="input-group">

                <label>
                  Current PDF:
                </label>

                <span>
                  {existingPdf}
                </span>

              </div>

            )}



            {/* PDF UPLOAD */}
            <div className="input-group">

              <label>
                Upload New PDF
              </label>

              <input
                type="file"
                accept=".pdf"
                onChange={
                  handleFileChange
                }
              />

            </div>



            {/* VIDEO URL */}
            <div className="input-group">

              <label>
                YouTube Video URL
              </label>

              <input
                type="text"
                value={videoUrl}
                onChange={(e) =>
                  setVideoUrl(
                    e.target.value
                  )
                }
                placeholder="Enter YouTube link"
              />

            </div>



            {/* BUTTONS */}
            <div className="form1-btns">

              <button className="btn-save">
                Update
              </button>


              <button
                type="button"
                className="btn-cancel"
                onClick={handleGoBack}
              >
                Cancel
              </button>

            </div>


          </form>

        </div>

      </div>

    </div>

  );

};

export default EditSchoolNotes;